let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cJ9EM")).then(() => parcelRequire('i4gYL'));